export function init() {
    // Attach click handler to bio links
    document.querySelectorAll('.js-team-bio-link').forEach(el => {
        el.addEventListener('click', e => {
            triggerBio(e, el);
        });
    });
}

function triggerBio(e, bioLink) {
    e.preventDefault();

    var person = bioLink.closest('.team--item');

    if (person.classList.contains('open')) {
        // Change link text
        bioLink.textContent = 'Read Bio';

        person.querySelector('.js-team-bio').classList.remove('open');
        
        person.classList.remove('open');

        setTimeout(function () {
            person.classList.remove('auto-height');
        }, 1000); // Should be same as .open transition time
    } else {
        // Change link text
        bioLink.textConten = 'Hide Bio';

        person.classList.add('auto-height');

        setTimeout(function () {
            person.classList.add('open');

            setTimeout(function () {
                person.querySelector('.js-team-bio').classList.add('open');
            }, 1000); // Should be same as .open transition time
        }, 750);
    }
}
